import { newDateFromUTC, newDateToUTC } from '@bc-library/common'

export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    return data.map((object: any) => afterReceivingOne(object))
  }

  if (data?.docs && Array.isArray(data.docs)) {
    return {
      ...data,
      docs: data.docs.map((object: any) => afterReceivingOne(object)),
    }
  }

  if (typeof data === 'object' && data !== null) {
    return afterReceivingOne(data)
  }

  return data
}

// The mission period of the coverage is a business period, like the campaign's
const coveragePeriodFromUTC = (period: any) => {
  if (!period) return period

  return {
    ...period,
    startDate: period.startDate && newDateFromUTC(period.startDate),
    endDate: period.endDate && newDateFromUTC(period.endDate),
  }
}

export const afterReceivingOne = (object: any) => {
  if (typeof object !== 'object' || object === null) return object

  return {
    ...object,
    _created: object._created && new Date(object._created),
    startDate: object.startDate && newDateFromUTC(object.startDate),
    endDate: object.endDate && newDateFromUTC(object.endDate),
    closedDate: object.closedDate && new Date(object.closedDate),
    coverage: coveragePeriodFromUTC(object.coverage),
  }
}

export const afterReceivingShowCampaign = (data: any) => {
  if (typeof data !== 'object' || data === null) return data

  return {
    ...data,
    campaign: data.campaign && afterReceivingOne(data.campaign),
  }
}

// Evaluated period: business dates; completion: a timestamp
export const afterReceivingCampaignDetails = (data: any) => {
  if (!Array.isArray(data?.rows)) return data

  return {
    ...data,
    rows: data.rows.map((row: any) => ({
      ...row,
      startDate: row.startDate && newDateFromUTC(row.startDate),
      endDate: row.endDate && newDateFromUTC(row.endDate),
      completedAt: row.completedAt && new Date(row.completedAt),
    })),
  }
}

export const afterReceivingCampaignCoverage = (data: any) => {
  if (!data?.coverage) return data

  return {
    ...data,
    coverage: { ...data.coverage, settings: coveragePeriodFromUTC(data.coverage.settings) },
  }
}

export const beforeSending = (data: any) => {
  if (data && Array.isArray(data)) {
    return data.map((object: any) => beforeSendingOne(object))
  }

  if (typeof data === 'object' && data !== null) {
    return beforeSendingOne(data)
  }

  return data
}

export const beforeSendingOne = (object: any) => {
  if (typeof object !== 'object' || object === null) return object

  return {
    ...object,
    startDate: object.startDate && newDateToUTC(object.startDate),
    endDate: object.endDate && newDateToUTC(object.endDate),
    ...(object.coverage
      ? {
          coverage: {
            ...object.coverage,
            startDate: object.coverage.startDate && newDateToUTC(object.coverage.startDate),
            endDate: object.coverage.endDate && newDateToUTC(object.coverage.endDate),
          },
        }
      : {}),
  }
}